import classes from '@/components/Shares/Input.module.css';
import { useAuth } from '@/providers/AuthProvider';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBlack } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Flex, Group, PasswordInput, Stack, Text, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import Link from 'next/link';
import { useCallback } from 'react';
import { AuthModalLayout } from './AuthModalLayout';
import { PlayButton } from './PlayButton';
import { SocialLinks } from './SocialLinks';
export type LoginFormData = {
  username: string;
  password: string;
};
export const Login: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setLogin
  } = useAuth();
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  const loginForm = useForm<LoginFormData>({
    mode: 'uncontrolled',
    initialValues: {
      username: '',
      password: ''
    },
    validate: {
      username: value => value.length < 0 ? i18n._('Username invalid') : null,
      password: value => value.length < 0 ? i18n._('Username invalid') : null
    }
  });
  const handleLogin = useCallback((data: LoginFormData) => {
    console.log(data);
    setLogin(true);
    setOpenModal(null);
  }, [setLogin, setOpenModal]);
  return <AuthModalLayout opened={openModal === MODAL.LOGIN} handleClose={() => setOpenModal(null)}>
      <Flex justify="center" h="100%" mx="auto" w={{
      base: '100%',
      sm: 524,
      xl: 427
    }} pb={{
      base: 268,
      md: 370,
      lg: 254
    }}>
        <form onSubmit={loginForm.onSubmit(values => handleLogin(values))} style={{
        width: '100%'
      }}>
          <Stack w="100%" gap={10}>
            <Text mb={10} component="h2" fz="h2" ta="center" tt="uppercase" c="var(--text-prime)" className={gunterzBlack.className}>
              {i18n._('Login')}
            </Text>

            <TextInput radius="sm" placeholder={i18n._('Username')} size="md" classNames={{
            input: classes.input_style_2
          }} {...loginForm.getInputProps('username')} />
            <PasswordInput radius="sm" type="password" placeholder={i18n._('Password')} size="md" classNames={{
            input: classes.input_style_2,
            innerInput: classes.innerInput
          }} {...loginForm.getInputProps('password')} />

            <Group justify="end">
              <Text onClick={() => setOpenModal(MODAL.FORGOT)} td="underline" tt="uppercase" fz="xs" fw={700} c="var(--text-blue)" style={{
              cursor: 'pointer'
            }}>
                {i18n._('Forgot your password?')}
              </Text>
            </Group>
            <PlayButton />

            <Stack align="center" mt={20} gap={20}>
              <Text tt="uppercase" fz="xs" fw={700} c="var(--text-dark)" onClick={() => setOpenModal(MODAL.REGISTER)}>
                {i18n._('New to prime roll?')}

                <Text component={Link} href="#" td="underline" c="var(--text-blue)" span inherit ml={4}>
                  {i18n._('Register')}
                </Text>
              </Text>

              <SocialLinks />
            </Stack>
          </Stack>
        </form>
      </Flex>
    </AuthModalLayout>;
};